import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <section className="about-modern">

      {/* Hero Section */}
      <div className="about-hero">
        <div className="about-hero-content">
          <h1>About <span>Budget Golden Triangle Tours</span></h1>

          <p>
            We specialize in affordable and well-planned Golden Triangle Tours
            covering Delhi, Agra, and Jaipur — India’s most iconic travel
            destinations. Our mission is to help travelers explore India's rich
            culture, heritage, and history with comfort, safety, and great value
            for money.
          </p>
        </div>

        <div className="about-hero-image">
          <img src="/Images/tour/golden-triangle-01.jpg.jpeg" alt="Golden Triangle Tour India" />
          <div className="about-image-overlay"></div>
        </div>
      </div>

      {/* Shape Gallery Section */}
      <div className="about-gallery">
        <div className="shape shape-angled-reverse">
          <img src="/Images/tour/golden-triangle-02.jpg.jpeg" alt="Delhi India" />
        </div>

        <div className="shape shape-blob">
          <img src="/Images/tour/golden-triangle-03.jpg.jpeg" alt="Taj Mahal Agra" />
        </div>

        <div className="shape shape-angled">
          <img src="/Images/tour/golden-triangle-04.jpg.jpeg" alt="Jaipur Rajasthan" />
        </div>
      </div>

      {/* About Text Section */}
      <div className="about-text">
        <h2>Who We Are</h2>

        <p>
          <b>Budget Golden Triangle Tours</b> is a trusted India tour operator
          offering carefully designed travel experiences across Delhi, Agra,
          and Jaipur — popularly known as the Golden Triangle circuit.
        </p>

        <p>
          From hotel bookings and private transportation to guided sightseeing
          and customized itineraries, we handle every detail so you can enjoy a
          smooth and memorable journey through India's royal heritage.
        </p>

        <p>
          Whether you are a first-time visitor to India, a family traveler, or a
          couple seeking cultural exploration, our budget-friendly packages
          ensure comfort, authenticity, and unforgettable experiences.
        </p>
      </div>

    </section>
  );
};

export default AboutUs;